import React, { useState,useEffect } from "react";
import Switch from "@mui/material/Switch";

const MySwitch = ({ isOn: initialIsOn, onClick, title }) => {
    const [isOn, setIsOn] = useState(initialIsOn);

    useEffect(() => {
        setIsOn(initialIsOn);
    }, [initialIsOn]);

    const handleToggle = (event) => {
        const newIsOn = event.target.checked;
        setIsOn(newIsOn);
        
        // Send back the new state as "On" or "Off" to the parent
        const newValue = newIsOn ? "On" : "Off";
        if (onClick) {
            onClick(title, newValue); // Pass title and the current newValue directly
        }
    };

    return (
        <Switch
            checked={isOn}
            onChange={handleToggle}
            sx={{
                "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "var(--success)",
                },
                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "var(--success)",
                },
                "& .MuiSwitch-track": {
                    backgroundColor: isOn ? "var(--success)" : "var(--danger)",
                },
                "& .MuiSwitch-switchBase:not(.Mui-checked)": {
                    color: "var(--danger)",
                },
            }}
        />
    );
};

export default MySwitch;
